import { useState } from "react";
import { ChatWidget } from "./BiteBot";

export const FloatingBot = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {open && (
        <div
          data-testid="floating-bot-panel"
          className="fixed bottom-44 right-4 z-[75] w-[380px] max-w-[calc(100vw-2rem)]"
        >
          <ChatWidget />
        </div>
      )}
      <button
        data-testid="floating-bitebot"
        onClick={() => setOpen((o) => !o)}
        aria-label="Chat with FUNZI"
        className="fixed bottom-24 right-4 z-[75] flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-[#7C3AED] to-[#06B6D4] text-2xl shadow-[0_16px_50px_-10px_rgba(108,99,255,0.65)] transition-transform hover:scale-110"
      >
        {open ? "✕" : "🤖"}
      </button>
    </>
  );
};
